// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2uPmV","savePackageButton":"ClientWallet_savePackageButton__2h008"};